import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext(null);
const savedUser = localStorage.getItem("user");
const userVal = (savedUser) ? savedUser : null;
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(userVal); 

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
